import React, { useEffect, useState } from "react";
import Sdk from "api.digitalpages.module.sdk.api";
import "./perfil.style.css";
import AvatarDefault from "./default-avatar.png";
import Loader from "./loader.gif";
import { IconCam } from "./icon-cam";

export const ViewProfile = () => {
  const [user, setUser] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const onUpdateProfile = async () => {
    const formData = new FormData();

    if (!avatarFile || !user) return;

    formData.append("profile", avatarFile);
    setLoading(true);

    await Sdk.Api.dynamic
      .bridge(`/auth/v1.1/user/me/thumb`, formData, "PUT")
      .then(() => {
        setUser({ ...user, avatar: URL.createObjectURL(avatarFile) });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getUser = async () => {
    var userDetails = await Sdk.Api.dynamic.bridge(
      `/auth/v1.0/user/me`,
      null,
      "GET"
    );
    const avatar = Sdk.Api.dynamic.bridgeUrl(
      `/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`
    );

    setUser({
      ...(userDetails || {}),
      avatar,
    });
  };

  const { name, first_name, last_name } = (user || { detail: {} }).detail;

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className="rdp-react-template-profile-home">
      {/* <Header
        name={user && user.detail && user.detail.name.split(" ")[0]}
        level="Nível 1"
        coins={null}
        coinsLabel="BV Coins"
        onCoinsClick={() => null}
        avatar={user && user.avatar ? user.avatar : undefined}
      /> */}
      <div className="rdp-react-template-profile-component-header">
        <button
          className="rdp-react-template-profile-component-header-btn"
          onClick={() => {
            window.location.hash = "/";
          }}
        ></button>
        <span className="rdp-react-template-profile-component-header-title">
          Meu perfil
        </span>
      </div>
      {/* <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500"> */}
      <div className="rdp-react-template-view-profile-content">
        <label
          htmlFor="chage-profile-input"
          className="rdp-react-template-profile-picture"
        >
          {!loading && <IconCam />}

          <img
            style={{
              ...(loading && {
                opacity: 0.2,
              }),
            }}
            className="rdp-image-profile"
            src={
              avatarFile
                ? URL.createObjectURL(avatarFile)
                : user && user.avatar
                ? user.avatar
                : undefined
            }
            alt="user-profile"
            onLoad={(e) => {
              URL.revokeObjectURL(e.target.src);
            }}
            onError={(e) => (e.target.src = AvatarDefault)}
          />
          {loading && <div className="loader"></div>}
        </label>
        <input
          onChange={(e) => {
            if (e.target.files) {
              const [file] = e.target.files;
              setAvatarFile(file);
            }
          }}
          type="file"
          hidden
          id="chage-profile-input"
        />
        <input
          placeholder="Nome"
          value={first_name || (name || "").split(" ")[0]}
        />
        <input
          placeholder="Sobrenome"
          value={last_name || (name || "").split(" ")[1]}
        />
        <button onClick={onUpdateProfile}>Salvar</button>
      </div>
      {/* </div> */}
    </div>
  );
};
